import { createSelector } from '@ngrx/store';

import { menuFlowsState } from '../root';

export const isDownloadingAnyMenuFlows = createSelector(menuFlowsState, (state) => Boolean(state.find((obj) => obj.isDownloading)));
